import Link from './component';

export default Link;
